(() => {
  const formatPolicy = field => {
    if (field.classList.contains('nero-policy')) return;
    const rows = Array.from(field.children);
    const isHeading = row => row.tagName === 'P' && row.children.length === 1 && row.firstElementChild.tagName === 'STRONG' && /^(Warranty|Returns)$/.test(row.textContent.trim());
    if (!rows.some(row => isHeading(row) && row.textContent.trim() === 'Warranty') || !rows.some(row => isHeading(row) && row.textContent.trim() === 'Returns')) return;
    field.classList.add('nero-policy');
    const output = document.createDocumentFragment();
    let section, content, actions;
    rows.forEach(row => {
      if (isHeading(row)) {
        section = document.createElement('section');
        section.className = 'nero-policy-section';
        const heading = document.createElement('h3');
        heading.className = 'nero-policy-heading';
        heading.textContent = row.textContent.trim();
        content = document.createElement('div');
        content.className = 'nero-policy-content';
        actions = document.createElement('div');
        actions.className = 'nero-policy-actions';
        section.append(heading, content, actions);
        output.append(section);
      } else if (content) {
        if (row.classList.contains('nero-resource-action')) actions.append(row);
        else {
          if (row.tagName === 'P') {
            if (row.textContent.includes('Australian Consumer Law')) row.classList.add('nero-policy-note');
            if (!content.children.length) {
              Array.from(row.childNodes).filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => {
                const match = node.textContent.match(/\b\d+\s+(?:years?|days?)\b/);
                if (!match) return;
                const emphasis = document.createElement('strong');
                emphasis.textContent = match[0];
                node.replaceWith(document.createTextNode(node.textContent.slice(0, match.index)), emphasis, document.createTextNode(node.textContent.slice(match.index + match[0].length)));
              });
            }
          }
          content.append(row);
        }
      } else output.append(row);
    });
    field.replaceChildren(output);
  };
  const enhanceLink = (link, part = false) => {
    if (link.classList.contains('nero-resource-button')) return;
    const original = link.textContent.trim();
    const format = original.match(/\s*\((PDF|PNG|SKP|RFA|ZIP|GLB|online)\)\s*$/i);
    const name = document.createElement('span');
    name.className = 'nero-resource-name';
    name.textContent = format ? original.slice(0, format.index).trim() : original;
    link.replaceChildren(name);
    if (format) {
      const badge = document.createElement('span');
      badge.className = 'nero-resource-format';
      badge.textContent = format[1].toUpperCase();
      link.append(badge);
    }
    const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrow.setAttribute('viewBox', '0 0 20 20');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.setAttribute('class', 'nero-resource-arrow');
    arrow.setAttribute('fill', 'none');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', link.origin === window.location.origin || part ? 'M4 10h12M11 5l5 5-5 5' : 'M5 15 15 5M5 5h10v10');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    arrow.append(path);
    link.append(arrow);
    link.classList.add('nero-resource-button');
    link.setAttribute('aria-label', original);
    if (link.target === '_blank') link.rel = 'noopener noreferrer';
    if (part) link.classList.add('nero-resource-button--part');
    if (link.pathname === '/products/nero-color-samples') link.classList.add('nero-resource-button--primary');
  };
  const init = root => {
    root.querySelectorAll('.accordion-details__content .metafield-rich_text_field').forEach(field => {
      const accordionHeading = field.closest('details')?.querySelector('summary')?.textContent.trim();
      if (accordionHeading === 'Maintenance & Care') field.classList.add('nero-care');
      if (accordionHeading === 'Order My Color Samples') field.classList.add('nero-samples');
      if (field.dataset.neroButtons || !field.querySelector('a')) return;
      field.dataset.neroButtons = 'true';
      const rows = Array.from(field.children);
      const isResourceList = rows.every(row => {
        const links = row.querySelectorAll('a');
        return links.length === 1 && row.textContent.trim() === links[0].textContent.trim() || links.length === 0 && !!row.querySelector('strong') && row.textContent.trim() === row.querySelector('strong').textContent.trim();
      });
      if (isResourceList) {
        field.classList.add('nero-resource-area');
        const output = document.createDocumentFragment();
        let group, grid;
        const addGroup = label => {
          group = document.createElement('div');
          group.className = 'nero-resource-group';
          if (label) { const heading = document.createElement('h3'); heading.className = 'nero-resource-label'; heading.textContent = label; group.append(heading); }
          grid = document.createElement('div'); grid.className = 'nero-resource-grid'; group.append(grid); output.append(group);
        };
        rows.forEach(row => {
          const link = row.querySelector('a');
          if (!link) { addGroup(row.textContent.trim()); return; }
          if (!grid) addGroup('');
          if (/\((SKP|RFA|ZIP|GLB)\)/i.test(link.textContent)) grid.classList.add('nero-resource-grid--models');
          enhanceLink(link); grid.append(link);
        });
        field.replaceChildren(output);
      } else {
        field.querySelectorAll('a').forEach(link => {
          const paragraph = link.parentElement;
          if (paragraph.tagName === 'P' && paragraph.querySelectorAll('a').length === 1) {
            const fragment = document.createDocumentFragment();
            let text = document.createElement('p');
            Array.from(paragraph.childNodes).forEach(node => {
              if (node === link) {
                if (text.lastChild?.nodeType === Node.TEXT_NODE) text.lastChild.textContent = text.lastChild.textContent.replace(/\s+[\u2014\u2013-]\s*$/, '.');
                if (text.textContent.trim()) fragment.append(text);
                const action = document.createElement('div'); action.className = 'nero-resource-action'; action.append(link); fragment.append(action); text = document.createElement('p');
              } else text.append(node);
            });
            if (text.textContent.trim() && text.textContent.trim() !== '.') fragment.append(text);
            paragraph.replaceWith(fragment);
          }
          enhanceLink(link);
        });
      }
      formatPolicy(field);
    });
    root.querySelectorAll('.nero-product-details table a').forEach(link => enhanceLink(link, true));
  };
  const start = () => document.querySelectorAll('[data-nero-resource-scope]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
